import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

function Bags({ user, bags, discsToBags }) {
  if (!user) {
    return <p className="discs-signin">Sign in to see your bags.</p>
  }

  if (bags.length === 0) {
    return <p className="discs-empty">No bags yet.</p>
  }

  const countFor = (bag) =>
    discsToBags.filter((link) => link.bu === bag.uuid).length

  return (
    <div className="bags-grid">
      {bags.map((bag) => (
        <Link key={bag.uuid} to={`/discs/bags/${bag.uuid}`} className="bag-card">
          <span className="bag-card--name">{bag.nm}</span>
          {bag.b && <span className="bag-card--brand">{bag.b}</span>}
          <span className="bag-card--count">
            {countFor(bag)}
            {bag.c ? ` / ${bag.c}` : ''} discs
          </span>
        </Link>
      ))}
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  bags: state.discs.bags,
  discsToBags: state.discs.discsToBags,
})

export default connect(mapStateToProps)(Bags)
